"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  permissions: function permissions(state) {
    return state.user.permissions;
  },
  sidebarRouters: function sidebarRouters(state) {
    return state.permission.sidebarRouters;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  isLogin: function isLogin(state) {
    return state.user.isLogin;
  }
};
var _default = exports.default = getters;